/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Icd10Model } from '../../models/icd-10-model';
import { PatientUpdateCaseIcd10Model } from '../../models/patient-update-case-icd-10-model';

export interface PatientCaseIcdUpdatePost$Params {
      body?: PatientUpdateCaseIcd10Model
}

export function patientCaseIcdUpdatePost(http: HttpClient, rootUrl: string, params?: PatientCaseIcdUpdatePost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<Array<Icd10Model>>> {
  const rb = new RequestBuilder(rootUrl, patientCaseIcdUpdatePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<Array<Icd10Model>>;
    })
  );
}

patientCaseIcdUpdatePost.PATH = '/Patient/CaseICDUpdate';
